<template>
  <section
    class="rev-ras-text-with-images-module-component"
    :style="{
      '--rev-ras-text-with-images-bg':
        props.data?.background_color || 'rgba(255, 255, 255, 1)',
    }">
    <img
      class="background"
      src="@/assets/img/rev_ras_bg_bottom.svg"
      alt="Background" />

    <div class="rr-container">
      <div class="content-container">
        <div class="left">
          <div
            class="title"
            v-html="props.data.title" />
          <div class="divider-container">
            <BicolorLine
              :bigger="true"
              left="balanced"
              right="progressive" />
          </div>

          <div
            class="content"
            v-html="props.data.content" />
        </div>
        <div class="right">
          <div
            ref="imagesContainerRef"
            class="images-container">
            <img
              ref="leftImageRef"
              class="left-image"
              :src="data.left_image.url"
              :alt="data.left_image.alt" />
            <img
              v-if="data.right_image.url"
              ref="rightImageRef"
              class="right-image"
              :src="data.right_image.url"
              :alt="data.right_image.alt" />
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script setup>
/* #META
 {
  "NAME": "RevRasTextWithImagesComponent",
  "CLASSNAME": "rev-ras-text-with-images-module-component",
  "URL": "http://vuevitewp.local/test"
 }
#ENDMETA */

/*
 * Insert your logic here
 */
import BicolorLine from '@/components/utility/BicolorLine.vue'
import { gsap } from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'
import { onBeforeUnmount, onMounted, ref } from 'vue'

gsap.registerPlugin(ScrollTrigger)

const props = defineProps(['data'])
const imagesContainerRef = ref(null)
const leftImageRef = ref(null)
const rightImageRef = ref(null)
const leftTweenRef = ref(null)
const rightTweenRef = ref(null)

onMounted(() => {
  if (!imagesContainerRef.value || !leftImageRef.value) return

  gsap.set(leftImageRef.value, { y: 40 })

  leftTweenRef.value = gsap.to(leftImageRef.value, {
    y: 0,
    ease: 'none',
    scrollTrigger: {
      trigger: imagesContainerRef.value,
      scrub: true,
      start: 'top bottom',
      end: 'center center',
      markers: false,
    },
  })

  if (rightImageRef.value) {
    gsap.set(rightImageRef.value, { y: -40 })

    rightTweenRef.value = gsap.to(rightImageRef.value, {
      y: 0,
      ease: 'none',
      scrollTrigger: {
        trigger: imagesContainerRef.value,
        scrub: true,
        start: 'top bottom',
        end: 'center center',
        markers: false,
      },
    })
  }
})

onBeforeUnmount(() => {
  if (leftTweenRef.value?.scrollTrigger) leftTweenRef.value.scrollTrigger.kill()
  if (rightTweenRef.value?.scrollTrigger)
    rightTweenRef.value.scrollTrigger.kill()
  if (leftTweenRef.value) leftTweenRef.value.kill()
  if (rightTweenRef.value) rightTweenRef.value.kill()
})
</script>

<style lang="scss" scoped>
.rev-ras-text-with-images-module-component {
  background-color: var(--rev-ras-text-with-images-bg);
  @apply relative pt-[30px] pb-[60px] lg:pt-[50px] lg:pb-[60px];

  .background {
    @apply absolute hidden top-0 right-0 w-[749px] object-top opacity-50 h-full object-contain z-[1] lg:block;
  }
  .rr-container {
    @apply w-full relative z-3 mx-auto;

    .content-container {
      @apply flex flex-col gap-10 lg:flex-row lg:gap-[76px];

      .left {
        @apply w-full flex flex-col order-2 lg:order-1 lg:max-w-[500px];
        @apply lg:gap-3 lg:flex-1;
        .title {
          :deep(*) {
            @apply header-2 text-balanced mb-6;
          }
        }

        .content {
          &:deep(*) {
            @apply text-[16px] leading-[1.2] text-black lg:text-[22px];
          }
        }

        .divider-container {
          @apply mb-7;
        }
      }

      .right {
        @apply w-full order-1 lg:w-[500px] lg:order-2 lg:flex-1;
        @apply xl:max-w-[694px] xl:w-[694px];

        .images-container {
          @apply relative pl-[20px] max-w-[350px] mx-auto pb-[75px];
          @apply lg:max-w-none lg:pl-0 lg:pr-[23px];

          img {
            @apply rounded-[27px] object-cover;

            &.left-image {
              @apply mr-0 ml-auto w-[228px] h-[228px] lg:w-[400px] lg:h-[400px] lg:ml-0 lg:mr-auto;
            }

            &.right-image {
              @apply w-[189px] h-[189px] absolute bottom-0 left-0;
              @apply lg:right-0 lg:left-auto lg:w-[281px] lg:h-[281px];
            }
          }
        }
      }
    }
  }
}
</style>
